import styled, {css} from 'styled-components';

const withError = css`
	height: var(--px-80);
`;

export default styled.div`
	.error {
		color: var(--red-600);
	}
	.user-selectbox {
		display: flex;
		align-items: center;

		.clearall {
			line-height: var(--px-45);
			margin: 0 var(--px-15);

			&.disabled {
				pointer-events: none;
				opacity: 0.5;
			}

			svg {
				vertical-align: middle;
				fill: var(--neutrals-1000);
			}
		}

		.enterdetail-loading {
			display: flex;
			align-items: center;
			justify-content: center;
			height: var(--px-45);
			width: var(--px-55);
			float: left;
			overflow: hidden;

			.motif-loader-container.nameemailloader {
				padding-top: var(--px-16);
			}
		}
	}
	.enterdetail-description {
		display: inline-block;
		width: 100%;
		font-size: var(--px-12);
		color: var(--neutrals-700);
		display: flex;
	}
	.user-selectbox {
		${({hasError}) => (hasError ? withError : '')};
		.react-select__indicator {
			svg {
				display: none;
			}
		}
	}
`;
